import { Role } from '@momentum/types';
import type { TFunction } from 'i18next';

const ROLE_KEY_MAP: Record<string, string> = {
  [Role.system_admin]: 'systemAdmin',
  [Role.admin]: 'admin',
  [Role.manager]: 'manager',
  [Role.employee]: 'employee',
};

/**
 * Get the display name for an employee role
 * @param role - The role from the Role enum (org:admin, org:manager, etc.)
 * @param t - The translation function from useTranslation('common')
 * @returns The translated display name for the employee role
 * @example
 * const { t } = useTranslation('common');
 * getEmployeeRoleDisplayName('org:employee', t) // Returns: "Employee" or "עובד"
 */
export const getEmployeeRoleDisplayName = (
  role: Role | string,
  t: TFunction<'common'>
): string => {
  const key = ROLE_KEY_MAP[role];
  if (!key) return role;
  return t(`employeeRoles.${key}` as never);
};
